import React, { useEffect, useState } from "react";
import styles from "../../styles/ArtworkPage.module.css";
import { getArtworks } from "../../lib/firebase/firestore";
import { Artwork } from "../../types";
import { ArtworkCard } from "../../components/ArtworkCard";

export const ArtworkPage = () => {
  const [artworks, setArtworks] = useState<Artwork[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArtworks = async () => {
      try {
        const data = await getArtworks();
        setArtworks(data);
      } catch (error) {
        console.error("Failed to fetch artworks:", error);
      } finally {
        setLoading(false);
      }
    };

    loadArtworks();
  }, []);

  if (loading) return <div>Loading artworks...</div>;

  return (
    <div className={styles.artworkContainer}>
      <h1>Artworks</h1>
      <div className={styles.artworkGrid}>
        {artworks.map((artwork) => (
          <ArtworkCard key={artwork.id} artwork={artwork} />
        ))}
      </div>
    </div>
  );
};
